// The server serializes the CAP <language> element from a Java enum, so it
// arrives as "HE" / "AR_IL" rather than the "he" / "ar-IL" of the raw XML.
// Reduce both shapes to a plain lowercase base tag so lookups by the UI locale
// keep working whichever form the server sends.
export function normalizeLang(lang) {
  if (!lang) return null;
  return String(lang).split(/[-_]/)[0].toLowerCase();
}

export function flattenCapAlert(alert) {
  const infos = Array.isArray(alert.info) ? alert.info : [alert.info || {}];
  const firstInfo = infos[0] || {};

  const flattenedInfos = infos.map((info) => {
    const areas = Array.isArray(info.area) ? info.area : [info.area || {}];

    const flattenedAreas = areas.map((area) => {
      const geocodes = Array.isArray(area.geocode)
        ? area.geocode
        : [area.geocode || {}];
      const geocodeMap = geocodes.reduce((acc, { valueName, value }) => {
        if (valueName && value) {
          acc[valueName] = value;
        }
        return acc;
      }, {});

      return {
        areaDesc: area.areaDesc,
        polygon: area.polygon,
        geocodes: geocodeMap,
      };
    });

    return {
      language: info.language,
      severity: info.severity,
      category: info.category,
      event: info.event,
      urgency: info.urgency,
      certainty: info.certainty,
      senderName: info.senderName,
      instruction: info.instruction,
      web: info.web,
      expires: info.expires,
      parameters: (Array.isArray(info.parameter)
        ? info.parameter
        : [info.parameter || {}]
      ).reduce((acc, { valueName, value }) => {
        if (valueName && value) {
          acc[valueName] = value;
        }
        return acc;
      }, {}),
      areas: flattenedAreas,
      layer: flattenedAreas[0]?.areaDesc || null,
      layers: flattenedAreas.map((a) => a.areaDesc).filter(Boolean),
      polygon: flattenedAreas[0]?.polygon || null,
    };
  });

  // Shared fields (lifted from first info, no check)
  const commonFields = [
    "language",
    "category",
    "event",
    "urgency",
    "severity",
    "certainty",
    "expires",
    "senderName",
    "web",
  ];

  const shared = {};
  for (const field of commonFields) {
    if (firstInfo[field] !== undefined) {
      shared[field] = firstInfo[field];
    }
  }

  // Collect unique layers across all infos
  const layers = [
    ...new Set(
      flattenedInfos
        .flatMap((info) => info.areas.map((area) => area.areaDesc))
        .filter(Boolean)
    ),
  ];

  // Build separate headline and description objects keyed by language
  const headlines = {};
  const descriptions = {};
  for (const info of infos) {
    const lang = normalizeLang(info.language);
    if (lang) {
      headlines[lang] = info.headline || null;
      descriptions[lang] = info.description || null;
    }
  }
  return {
    ...alert,
    ...shared,
    headlines,
    descriptions,
    infos: flattenedInfos,
    layers,
    rawXml: alert.rawXml,
    messageSize: new TextEncoder().encode(alert.rawXml).length,
  };
}
